export default "__VITE_ASSET__DVOpcAEi__"